export default __webpack_public_path__ + "static/media/41_BottomRightSquares_Left.2989f11b.mp4";